export default __webpack_public_path__ + "static/media/logo_blue.4b459de1.svg";